import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { getLicenseInfo } from '../api'
import { IMarketingProduct } from '../typings'
import { unwrapResult } from '@reduxjs/toolkit'

export const useGetLicensingInfoOnMount = () => {
  const dispatch = useAppDispatch()
  const [licensingStatus, setStatus] = useState<
    'idle' | 'pending' | 'success' | 'fail'
  >('idle')
  const [licensingInfo, setLicenseInfo] = useState<IMarketingProduct[]>([])
  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')
        const result = await dispatch(getLicenseInfo())

        if (mounted) {
          if (getLicenseInfo.fulfilled.match(result)) {
            setStatus('success')
            unwrapResult(result)
            setLicenseInfo(result.payload)
          } else {
            setStatus('fail')
            toast.error(`Error loading license info`)
            setLicenseInfo([])
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
          setLicenseInfo([])
        }
      } finally {
        if (mounted) setStatus('idle')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return { licensingStatus, licensingInfo }
}
